// extracted by mini-css-extract-plugin
module.exports = {"TCSection":"TCSection_TCSection__rhgzM","ef-box":"TCSection_ef-box__zeVzb"};